export type Tone = 'ok' | 'warn' | 'busy' | 'calm' | 'info';

const pillTone: Record<Tone, string> = {
  ok: 'border-secondary-200 bg-secondary-100 text-secondary-900',
  warn: 'border-accent-200 bg-accent-100 text-accent-900',
  busy: 'border-background-300 bg-background-200 text-foreground-700',
  calm: 'border-primary-200 bg-primary-100 text-primary-900',
  info: 'border-background-200 bg-background-100 text-foreground-700',
};

const dotTone: Record<Tone, string> = {
  ok: 'bg-secondary-500',
  warn: 'bg-accent-500',
  busy: 'bg-foreground-400',
  calm: 'bg-primary-500',
  info: 'bg-foreground-500',
};

interface StatusPillProps {
  label: string;
  tone: Tone;
  dot?: boolean;
}

export default function StatusPill({ label, tone, dot = true }: StatusPillProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-1 text-xs font-medium ${pillTone[tone]}`}
    >
      {dot && (
        <span className={`h-1.5 w-1.5 rounded-full ${dotTone[tone]} ${tone === 'ok' ? 'animate-pulse-dot' : ''}`} />
      )}
      {label}
    </span>
  );
}